import { batch, observable } from '@legendapp/state';
import type { Tab } from '../types';
import { autoBetState$ } from './auto-bet.state';
import { towersState$ } from './towers.state';
import { winDisplayState$ } from './win-display.state';

type UIState = {
  activeTab: Tab;
  soundTurnedOn: boolean;
  toggleSound: () => void;
  setSoundTurnedOn: (isTurnedOn: boolean) => void;
  setActiveTab: (tab: Tab) => void;
};

export const uiState$ = observable<UIState>({
  activeTab: 'manual',
  soundTurnedOn: true,
  toggleSound: () => {
    uiState$.soundTurnedOn.set(!uiState$.soundTurnedOn.peek());
  },
  setActiveTab: (tab: Tab) => {
    batch(() => {
      towersState$.resetBricks();
      autoBetState$.resetAutoBetStats();
      autoBetState$.resetPickedBricks();
      winDisplayState$.hideWinDisplay();
      uiState$.activeTab.set(tab);
    });
  },
  setSoundTurnedOn: (isTurnedOn: boolean) => {
    uiState$.soundTurnedOn.set(isTurnedOn);
  },
});
